import { isArray } from "underscore";

class ResponseMaker {
    data = {};
    data_to_send = {
        data: [],
        shipToAddressId: null
    };

    constructor(data) {
        this.data = data;
    }

    process = () => {
        let d = this.data
        if (d.data !== undefined && isArray(d.data)) {
            d.data.map((v, i) => {
                if (!v.partNumber || v.partNumber === '' || v.partNumber === '' || v.partNumber === '0') {
                    d.data[i].partNumber = v.itemNumber;
                }
                // Round Off Sub Total
                if (v.subtotal) {
                    d.data[i].subtotal = Math.round((v.subtotal + Number.EPSILON) * 100) / 100
                }

                if (v.quantity) {
                    let totalQuantity = 0;
                    let shipmentDetail = v.scheduleDetails;
                    if (isArray(shipmentDetail) && shipmentDetail.length > 0) {
                        shipmentDetail.map((p, j) => {
                            totalQuantity = totalQuantity + p.quantity;
                        });
                        
                        if (totalQuantity > v.quantity) {
                            d.data[i].isScheduleTotalQtyValid = false
                        } else {
                            d.data[i].isScheduleTotalQtyValid = true
                        }
                    } else {
                        d.data[i].isScheduleTotalQtyValid = true
                    }
                }
            });
        }
        this.data_to_send = d;
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return this.data_to_send;
    };
}

export default ResponseMaker;